module.exports = __webpack_public_path__ + "static/media/7p0egmj9o1tdri34.a7fd2908.png";